import React from "react"
import { Box, Tooltip } from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"

const ColorBox = ({ colorOption, clickable, handleColorSelect, selected }) => {
  const isLight = ["#ffffff", "#fff200", "#F5F5F5", "#fff9c7"].includes(colorOption.value) ||
    (colorOption.value && parseInt(colorOption.value.replace('#',''), 16) > 0xcccccc)

  return (
    <Tooltip title={colorOption?.extra_data?.name} key={colorOption.value}>
      <Box
        sx={{
          width: 48,
          height: 48,
          bgcolor: colorOption.value,
          border: selected ? "3px solid #c8b99a" : isLight ? "1px solid rgba(255,255,255,0.2)" : "1px solid transparent",
          m: 0.5,
          borderRadius: 1.5,
          cursor: clickable ? "pointer" : null,
          transition: "all 0.15s",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: selected ? "0 0 8px rgba(200,185,154,0.5)" : null,
          "&:hover": {
            border: "2px solid rgba(255,255,255,0.4)",
            transform: "scale(1.08)",
          },
        }}
        onClick={() => {
          if (clickable) {
            handleColorSelect(colorOption)
          }
        }}
      >
        {selected && (
          <CheckIcon sx={{ fontSize: 20, color: isLight ? "#333" : "#fff", filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.5))" }} />
        )}
      </Box>
    </Tooltip>
  )
}

export default ColorBox
